import { createSlice } from "@reduxjs/toolkit"

const extractTime = timeAsString => {
  return timeAsString.split(",").map(ts => Number(ts))
}

const makeTimePair = (startStr, endStr) => {
  const start = extractTime(startStr)
  const end = extractTime(endStr)
  let pairs = []
  start.forEach((t, i) => pairs.push([t, end[i]]))
  return pairs
}

const makeScoringDivisions = (times, divisions) => {
  let main = []
  // loop through the start end time pairs
  for (let j = 0; j < times.length; j++) {
    let array = [times[j][0]]
    // loop through the number of divisions to be created
    for (let i = 1; i <= divisions; i++) {
      //start + ((end - start)/no.of divisions) * i
      array.push(times[j][0] + ((times[j][1] - times[j][0]) / divisions) * i)
    }
    main.push(array)
  }
  return main
}

const calculateScore = (t, startEndTimes, scoreDivisionTimes, scored) => {
  let score = 0

  // check if time lies within one of the startEnd pairs
  let correct = false
  let pair
  for (let i = 0; i < startEndTimes.length; i++) {
    if (t >= startEndTimes[i][0] && t < startEndTimes[i][1]) {
      correct = true
      pair = i
      break
    }
  }

  // return 0
  if (!correct) return [score]

  // calculate score
  for (let i = scoreDivisionTimes[pair].length - 1, j = 0; i > 0; i--, j++) {
    if (
      t >= scoreDivisionTimes[pair][j] &&
      t < scoreDivisionTimes[pair][j + 1]
    ) {
      score = i
      break
    }
  }
  return [score, pair]
}

export const slice = createSlice({
  name: "hazard",
  initialState: {
    url: null,
    seeking: false,
    loading: false,
    playing: false,
    reviewing: false,
    ended: false,
    cheating: false,
    played: 0,
    loaded: 0,
    playedSeconds: 0,
    loadedSeconds: 0,
    duration: 0,
    startEndTimes: [],
    scoreDivisionTimes: [],
    isScored: [],
    timesClicked: [],
    maxScore: 0,
    currentScore: 0,
  },
  reducers: {
    loadVideo: (state, { payload }) => {
      state.url = payload
    },
    playPauseVideo: state => {
      state.playing = !state.playing
    },
    progressVideo: (
      state,
      { payload: { loaded, played, loadedSeconds, playedSeconds } }
    ) => {
      if (state.playing) {
        state.loaded = loaded
        state.played = played
        state.loadedSeconds = loadedSeconds
        state.playedSeconds = playedSeconds
      }
    },
    seekTo: (state, { payload }) => {
      state.played = payload.played
      state.playedSeconds = payload.playedSeconds
    },
    setSeeking: (state, { payload }) => {
      state.seeking = payload
    },
    endVideo: state => {
      state.ended = true
      state.playing = false
      state.reviewing = false

      if (state.duration === 0) {
        state.duration = state.playedSeconds
      }
    },
    setDuration: (state, { payload }) => {
      state.duration = payload
    },
    setStartEndTimes: (state, { payload: { start, end } }) => {
      state.startEndTimes = makeTimePair(start, end)
      state.scoreDivisionTimes = makeScoringDivisions(state.startEndTimes, 5)
      state.maxScore = state.startEndTimes.length * 5
    },
    registerClickOnVideo: state => {
      if (!state.cheating) {
        // If use is not cheating --> continue.

        if (state.timesClicked.length < 20) {
          // If less than 20 clicks in total --> continue

          if (state.timesClicked.length <= 5) {
            state.timesClicked.push([state.playedSeconds, state.played])
            const score = calculateScore(
              state.playedSeconds,
              state.startEndTimes,
              state.scoreDivisionTimes
            )
            // check if score!==0 and if there has been a scoring in the current startEnd time pair
            if (score[0] !== 0 && !state.isScored.includes(score[1])) {
              state.currentScore += score[0]
              state.isScored.push(score[1])
            }
          } else if (
            state.timesClicked.length > 5 &&
            state.playedSeconds -
              state.timesClicked[state.timesClicked.length - 5][0] >
              5
          ) {
            state.timesClicked.push([state.playedSeconds, state.played])

            const score = calculateScore(
              state.playedSeconds,
              state.startEndTimes,
              state.scoreDivisionTimes
            )
            if (score[0] !== 0 && !state.isScored.includes(score[1])) {
              state.currentScore += score[0]
              state.isScored.push(score[1])
            }
          } else {
            state.cheating = true //Set as cheating for clicking too fast
            state.playing = false
          }
        } else {
          state.cheating = true //Set as cheating for more than 20 total clicks
          state.playing = false
        }
      }
    },
    startReview: state => {
      state.playing = true
      state.reviewing = true
    },
    reset: state => {
      state.url = null
      state.seeking = false
      state.loading = false
      state.playing = false
      state.ended = false
      state.cheating = false
      state.played = 0
      state.loaded = 0
      state.playedSeconds = 0
      state.loadedSeconds = 0
      state.duration = 0
      state.startEndTimes = []
      state.scoreDivisionTimes = []
      state.isScored = []
      state.timesClicked = []
      state.maxScore = 0
      state.currentScore = 0
      state.reviewing = 0
    },
  },
})

export const selectUrl = state => state.hazard.url
export const selectSeeking = state => state.hazard.seeking
export const selectLoading = state => state.hazard.loading
export const selectPlaying = state => state.hazard.playing
export const selectReviewing = state => state.hazard.reviewing
export const selectEnded = state => state.hazard.ended
export const selectCheating = state => state.hazard.cheating
export const selectPlayed = state => state.hazard.played
export const selectLoaded = state => state.hazard.loaded
export const selectDuration = state => state.hazard.duration
export const selectPlayedSeconds = state => state.hazard.playedSeconds
export const selectLoadedSeconds = state => state.hazard.loadedSeconds
export const selectStartEndTimes = state => state.hazard.startEndTimes
export const selectScoreDivisionTimes = state => state.hazard.scoreDivisionTimes
export const selectTimesClicked = state => state.hazard.timesClicked
export const selectMaxScore = state => state.hazard.maxScore
export const selectCurrentScore = state => state.hazard.currentScore

export const {
  loadVideo,
  setDuration,
  setSeeking,
  playPauseVideo,
  progressVideo,
  endVideo,
  setStartEndTimes,
  registerClickOnVideo,
  reset,
  startReview,
  seekTo,
} = slice.actions

export default slice.reducer
